<template>
    <div v-if="deal.pipeline_step_id">
        <h5 class="m-0"><i class="fa-fw fa fa-toggle-right"></i> {{ $t('pipeline') }} - {{ pipeline.name }}</h5>
        <div class="m-b-10 bg_load_null" v-pml-block="isSaving">
            <div class="pipeline pipeline_deal">
                <div v-for="step in pipeline.steps" class="box_pipeline" :class="{ 'step_completed': step.step < dealStep.step, 'active': step.step === dealStep.step }" @click="setPipeline(step.id)">
                    <span class="pipeline_name">{{ step.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { update } from 'services/deals'
    import { findPipelineByStepId } from 'utils/helpers/find-store'
    import { cloneDeep, find } from 'lodash'

    export default {
        name: 'DealPipeline',
        props: [ 'deal' ],
        data () {
            return {
                isSaving: false
            }
        },
        computed: {
            pipeline () {
                return findPipelineByStepId(this.deal.pipeline_step_id) || {}
            },
            dealStep () {
                return find(this.pipeline.steps, { id: this.deal.pipeline_step_id })
            }
        },
        methods: {
            setPipeline (id) {
                if (id === this.deal.pipeline_step_id) return

                this.isSaving = true

                let deal = cloneDeep(this.deal)
                deal.pipeline_step_id = id

                update(this.deal.id, deal)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/Pipeline.vue